import angular from 'angular';
import { STATES } from '../../constants/';
import { Config } from './insurance-questionnaire.config.js';

export const Module = angular
  .module(STATES.INSURANCE_QUESTIONNAIRE, [])
  .config(Config);
